export const createRootStyle = () => ({
  background: 'rgba(0, 0, 0, 0.5)',
  boxShadow: '0px 8px 11px -5px rgba(0, 0, 0, 0.2), 0px 17px 26px 2px rgba(0, 0, 0, 0.14), 0px 6px 32px 5px rgba(0, 0, 0, 0.12)',
  borderRadius: '15px',
  minWidth: { xs: '100%', md: '700px' },
  minHeight: { xs: '100%', md: '541px' },
  maxHeight: 'calc(100vh - 32px)',
  width: { xs: '100%', md: 'fit-content' },
  // eslint-disable-next-line no-nested-ternary
  height: { xs: '100%', md: 'fit-content', lg: 'fit-content' },
  padding: '0',
  position: 'absolute',
  right: { xs: 0, md: '16px' },
  left: { xs: 0, md: '16px' },
  top: '16px',
  bottom: '16px',
  margin: 'auto',
  zIndex: 3,
  textAlign: 'center',
});
